function normalizeBasePath(basePath: string | undefined): string {
  const raw = (basePath || '/').trim()
  if (!raw || raw === '/') return '/'
  return `/${raw.replace(/^\/+|\/+$/g, '')}`
}

function normalizeAbsoluteOrPathBase(base: string): string {
  if (/^[a-z][a-z\d+\-.]*:\/\//i.test(base)) return base.replace(/\/+$/g, '')
  return normalizeBasePath(base)
}

function joinBase(base: string, path: string): string {
  const cleanPath = path ? `/${path.replace(/^\/+/g, '')}` : ''
  if (/^[a-z][a-z\d+\-.]*:\/\//i.test(base)) return `${base}${cleanPath}`
  if (base === '/') return cleanPath || '/'
  return `${base}${cleanPath}`
}

export const APP_BASE_PATH = normalizeBasePath(import.meta.env.BASE_URL)

export function appPath(path = ''): string {
  return joinBase(APP_BASE_PATH, path)
}

export function getCurrentAppPathname(pathname = window.location.pathname): string {
  if (APP_BASE_PATH !== '/' && (pathname === APP_BASE_PATH || pathname.startsWith(`${APP_BASE_PATH}/`))) {
    const next = pathname.slice(APP_BASE_PATH.length)
    return next || '/'
  }
  return pathname || '/'
}

export function navigateToAppPath(path: string, replace = false) {
  const target = appPath(path)
  if (replace) {
    window.location.replace(target)
    return
  }
  window.location.assign(target)
}

export function apiPath(path = ''): string {
  const configured = import.meta.env.VITE_API_BASE_URL?.trim()
  if (configured) return joinBase(normalizeAbsoluteOrPathBase(configured), path)
  return appPath(`api/${path.replace(/^\/+/g, '')}`)
}

export function getCesiumBaseUrl(): string {
  const configured = import.meta.env.VITE_CESIUM_BASE_URL?.trim()
  if (configured) return joinBase(normalizeAbsoluteOrPathBase(configured), '')
  return appPath('cesium')
}
